import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const EditorTexto = ({ valueEdit, setValueEdit, keyEditor, placeholder, width, height }) => {
    const [ valorEdit, setValorEdit ] = useState("");
    const editarValor = (content) => {
        setValorEdit(content);
        setValueEdit(keyEditor, content);
    }

    useEffect(() => {
        setValorEdit(valueEdit)
    },[])

    return(
        <>
            <ReactQuill
                theme="snow"
                modules={
                {
                    toolbar: [
                        [{ 'color': [] }, { 'background': [] }],
                        [{ header: [1, 2, false] }],
                        ['bold', 'italic', 'underline'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listas
                        // ['image', 'code-block'],
                    ]
                }}
                value={valorEdit}
                onChange={editarValor}
                className="custom-quill bg-zinc-900 border-gray-500"

                // style={{ width: ( width ? width : '600px'), height: (height ? height : 'auto'), background:'#fff', color: '#000', }}
                // placeholder={ placeholder ? placeholder : 'Escriba aquí...'}
            />
        </>
    )
}